class t {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return a = a.replace(/[^a-zA-Z0-9]/g, ""), !!a.match(/^(([135-7][0-9])|(2[5-9])|(4[0-467]))[0-9]{3}$/);
  }
}
export {
  t as default
};
